import {
	ADMINGETINTEGRATIONLIST_SUCCESS,
	ADMINGETINTEGRATIONLIST_FAILED,
	RESET_ADMINGETINTEGRATIONLIST,
	LOADING_ADMINGETINTEGRATIONLIST,
	NETWORK_ERROR_ADMINGETINTEGRATIONLIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetIntegrationList = () => {
	return { type: RESET_ADMINGETINTEGRATIONLIST };
};

const adminGetIntegrationList = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETINTEGRATIONLIST });
	await adminServices
		.post("getIntegrationList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetIntegrationListsuccess(res.data));
					break;
				default:
					dispatch(adminGetIntegrationListFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETINTEGRATIONLIST,
				payload: err
			});
		});
};
function adminGetIntegrationListsuccess(data) {
	return {
		type: ADMINGETINTEGRATIONLIST_SUCCESS,
		payload: data
	};
}
function adminGetIntegrationListFailed(data) {
	return {
		type: ADMINGETINTEGRATIONLIST_FAILED,
		payload: data
	};
}

export { resetAdminGetIntegrationList, adminGetIntegrationList };
